export const PADDLE_ENVIRONMENT = 'production';
export const PADDLE_TOKEN = 'live_48aa838451a6f4353b07180f7aa';
